import DefinitionEditor from '../definition/DefinitionEditor';

/**
 * Slide-scoped stain details editor. Reuses DefinitionEditor so Case Builder
 * stays consistent with other definition surfaces.
 *
 * layout="embedded": no overlay — use inside assign-sheet subviews.
 * hideFooter: parent owns sticky Cancel/Save via actionsRef.
 */
export default function StainDetailsForm({
    stain,
    open,
    onSave,
    onCancel,
    layout = 'modal',
    hideChrome = false,
    hideFooter = false,
    saveLabel = null,
    cancelLabel = null,
    subtitle = null,
    readOnly = false,
    onDirtyChange = null,
    actionsRef = null,
}) {
    if (!open || !stain) return null;

    return (
        <DefinitionEditor
            type="stain"
            definition={stain}
            onSave={onSave}
            onCancel={onCancel}
            isOpen={true}
            detailsOnly={true}
            definitionContext={false}
            layout={layout}
            hideChrome={hideChrome}
            hideFooter={hideFooter}
            saveLabel={saveLabel}
            cancelLabel={cancelLabel}
            subtitle={subtitle}
            readOnly={readOnly}
            onDirtyChange={onDirtyChange}
            actionsRef={actionsRef}
        />
    );
}
